/**
 * Wage standardization utilities for comparing wages across different time periods
 * Used for prevailing wage comparisons in LCA forms
 */

export const wageMultiplier = {
  HourWeek: 40,
  WeekHour: 1 / 40,
  "HourBi-Weekly": 80,
  "Bi-WeeklyHour": 1 / 80,
  HourMonth: 173.333,
  MonthHour: 1 / 173.333,
  HourYear: 2080,
  YearHour: 1 / 2080,
  "WeekBi-Weekly": 2,
  "Bi-WeeklyWeek": 1 / 2,
  WeekMonth: 4,
  MonthWeek: 1 / 4,
  WeekYear: 52,
  YearWeek: 1 / 52,
  "Bi-WeeklyMonth": 2,
  "MonthBi-Weekly": 1 / 2,
  "Bi-WeeklyYear": 26,
  "YearBi-Weekly": 1 / 26,
  MonthYear: 12,
  YearMonth: 1 / 12,
};

/**
 * Normalizes wage period strings to standardized format
 * @param {string} per - The wage period (e.g., "HOURLY", "hour", "Hour")
 * @returns {string} - Standardized period ("Hour", "Week", "Bi-Weekly", "Month", "Year")
 */
export const rateMapper = (per) => {
  switch (per?.toUpperCase()) {
    case "HOURLY":
    case "HOUR":
      return "Hour";
    case "WEEKLY":
    case "WEEK":
      return "Week";
    case "BIWEEKLY":
    case "BI-WEEKLY":
      return "Bi-Weekly";
    case "MONTHLY":
    case "MONTH":
      return "Month";
    case "ANNUAL":
    case "YEAR":
      return "Year";
    default:
      return per;
  }
};
